import BarChartIcon from '@mui/icons-material/BarChart';
import BookOnlineSharpIcon from '@mui/icons-material/BookOnlineSharp';
import ContentPasteIcon from '@mui/icons-material/ContentPaste';
import EventIcon from '@mui/icons-material/Event';
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import InventoryIcon from '@mui/icons-material/Inventory';
import LocalPharmacyIcon from '@mui/icons-material/LocalPharmacy';
import MedicalServicesIcon from '@mui/icons-material/MedicalServices';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import PersonRoundedIcon from '@mui/icons-material/PersonRounded';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import ScannerIcon from '@mui/icons-material/Scanner';
import VaccinesIcon from '@mui/icons-material/Vaccines';
import $ from 'jquery';
import { useEffect, useState } from 'react';
import { TbReportAnalytics } from 'react-icons/tb';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { dvtabs, sidebar, sidenav } from '../Redux/Slice/rootSlice';
import '../styles/sidenav.scss';

function SideBar() {
  const sideactive = useSelector(state => state.counter.sidebarnav);
  const userdata = useSelector(state => state.counter.userdata);
  const sidebarstate = useSelector(state => state.counter.sidebar);

  const dispatch = useDispatch();
  const [expand, setExpand] = useState(null);

  // Responsive sidebar close on window resize
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 920) {
        dispatch(sidenav(false));
      }
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [dispatch]);

  // Sidebar nav items
  const navData = [
    {
      id: 0,
      icon: <HomeRoundedIcon style={{padding: '10px', fontSize: '46px'}} />,
      text: 'DashBoard',
      className: `adminusernav${sidebarstate === 'DashBoard' ? ' activesidemenu' : ''}`,
      link: '/'
    },
    {
      id: 1,
      icon: <PersonRoundedIcon style={{padding: '10px', fontSize: '46px'}} />,
      text: 'Patient Details',
      className: `doctorsidebar${sidebarstate === 'Patient Details' ? ' activesidemenu' : ''}`,
      link: '/Patients'
    },
    ...(userdata.role !== 'Staff'
      ? [
          {
            id: 2,
            icon: <TbReportAnalytics style={{padding: '10px', fontSize: '46px'}} />,
            text: 'Patient Reports',
            className: `doctorsidebar${sidebarstate === 'Patient Reports' ? ' activesidemenu' : ''}`,
            link: '/patientreports'
          }
        ]
      : []),
    {
      id: 3,
      icon: <ReceiptLongIcon style={{padding: '10px', fontSize: '46px'}} />,
      text: 'Patient Billing',
      className: `doctorsidebar${sidebarstate === 'Patient Billing' ? ' activesidemenu' : ''}`,
      link: '/patient_billing'
    },
    {
      id: 4,
      icon: <BookOnlineSharpIcon style={{padding: '10px', fontSize: '46px'}} />,
      text: 'Appointment',
      className: `doctorsidebar${sidebarstate === 'Appointment' ? ' activesidemenu' : ''}`,
      link: '/appointment'
    },
    ...(userdata.role === 'Admin'
      ? [
          {
            id: 5,
            icon: <PersonAddIcon style={{padding: '10px', fontSize: '46px'}} />,
            text: 'User List',
            className: `doctorsidebar${sidebarstate === 'User List' ? ' activesidemenu' : ''}`,
            link: '/user_list'
          }
        ]
      : []),
    {
      id: 6,
      icon: <InventoryIcon style={{padding: '10px', fontSize: '46px'}} />,
      text: 'Drug Inventory',
      className: `doctorsidebar${sidebarstate === 'Drug Inventory' ? ' activesidemenu' : ''}`,
      link: '/druginventory'
    },
    {
      id: 7,
      icon: <EventIcon style={{padding: '10px', fontSize: '46px'}} />,
      text: 'In Patient',
      className: `doctorsidebar${sidebarstate === 'In Patient' ? ' activesidemenu' : ''}`,
      link: '/inpatient'
    },
    {
      id: 8,
      icon: <EventIcon style={{padding: '10px', fontSize: '46px'}} />,
      text: 'Fertility',
      className: `doctorsidebar${sidebarstate === 'Fertility' ? ' activesidemenu' : ''}`,
      link: '/fertility'
    },
    {
      id: 9,
      icon: <BarChartIcon style={{padding: '10px', fontSize: '46px'}} />,
      text: 'Report',
      className: `doctorsidebar${sidebarstate === 'Report' ? ' activesidemenu' : ''}`,
      link: '/reportDetails',
      subMenus: [
        {
          id: 10,
          icon: <LocalPharmacyIcon style={{padding: '5px', fontSize: '30px'}} />,
          text: 'Pharmacy',
          className: `doctorsidebar${sidebarstate === 'Pharmacy' ? ' activesidemenu' : ''}`,
          link: '/reportDetails/pharmacy'
        },
        {
          id: 11,
          icon: <ScannerIcon style={{padding: '5px', fontSize: '30px'}} />,
          text: 'Scan Report',
          className: `doctorsidebar${sidebarstate === 'Scan Report' ? ' activesidemenu' : ''}`,
          link: '/scan_report'
        },
        {
          id: 12,
          icon: <MedicalServicesIcon style={{padding: '5px', fontSize: '30px'}} />,
          text: 'Procedure Report',
          className: `doctorsidebar${sidebarstate === 'Procedure Report' ? ' activesidemenu' : ''}`,
          link: '/procedure_report'
        },
        {
          id: 13,
          icon: <PeopleAltIcon style={{padding: '5px', fontSize: '30px'}} />,
          text: 'Consultation Report',
          className: `doctorsidebar${sidebarstate === 'Consultation Report' ? ' activesidemenu' : ''}`,
          link: '/consultation_report'
        },
        {
          id: 14,
          icon: <VaccinesIcon style={{padding: '5px', fontSize: '30px'}} />,
          text: 'Injection Report',
          className: `doctorsidebar${sidebarstate === 'Injection Report' ? ' activesidemenu' : ''}`,
          link: '/Injection_report'
        },
        {
          id: 15,
          icon: <ContentPasteIcon style={{padding: '5px', fontSize: '30px'}} />,
          text: 'OT Report',
          className: `doctorsidebar${sidebarstate === 'OT Report' ? ' activesidemenu' : ''}`,
          link: '/ot_report'
        }
      ]
    }
  ];

  // Collect all submenu texts and their indices for expand logic
  const submenuMap = {};
  navData.forEach((item, index) => {
    if (item.subMenus) {
      item.subMenus.forEach(sub => {
        submenuMap[sub.text] = index;
      });
    }
  });

  const sidebarHandleClick = text => {
    if (text !== 'Settings' && text !== 'Diagnostics') {
      dispatch(sidebar(text));
    }
    dispatch(dvtabs('About'));
  };

  const onMouseEnter = () => {
    if (!sideactive) {
      $('.sidebarclose').css('width', '240px');
      $('.linkTextclosed').css('display', 'block');
      $('.arrow').css('display', 'block');
    }
    if (submenuMap[sidebarstate] !== undefined) {
      setExpand(submenuMap[sidebarstate]);
    }
  };

  const onMouseLeave = () => {
    if (!sideactive) {
      $('.sidebarclose').css('width', '65px');
      $('.linkTextclosed').css('display', 'none');
      $('.arrow').css('display', 'none');
      setExpand(null);
    }
  };

  useEffect(() => {
    if (!sideactive) setExpand(null);
  }, [sideactive]);

  useEffect(() => {
    if (sideactive && submenuMap[sidebarstate] !== undefined) {
      setExpand(submenuMap[sidebarstate]);
    }
  }, [sideactive, sidebarstate]);

  const toggleExpand = index => {
    setExpand(prev => (prev === index ? null : index));
  };

  return (
    <div className={sideactive ? 'sidebar' : 'sidebarclose'} id='sidebar' onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
      <div className='sidebar-inner slimscroll'>
        <div id='sidebar-menu' className='sidebar-menu'>
          <ul className='sidebar_content'>
            {navData.map((item, index) =>
              item.icon ? (
                <div key={item.id}>
                  <NavLink to={item.link} style={{textDecoration: 'none'}}>
                    <li
                      className={`sideitem row ${item.className}`}
                      onClick={() => {
                        sidebarHandleClick(item.text);
                        if (item.subMenus) toggleExpand(index);
                      }}>
                      <div className='col-2' style={{width: '65px'}}>
                        {item.icon}
                      </div>
                      <div className={sideactive ? 'linkText col-6' : 'linkTextclosed col-6'}>
                        <NavLink className='nav-link' to={item.link}>
                          {item.text}
                        </NavLink>
                      </div>
                      {item.subMenus && (
                        <i
                          className={`bi bi-caret-right-fill arrow col-2${expand === index ? ' arrowexpand' : ''}`}
                          style={{display: sideactive ? 'block' : 'none', marginLeft: '10px'}}
                          onClick={e => {
                            // e.stopPropagation();
                            toggleExpand(index);
                          }}></i>
                      )}
                    </li>
                  </NavLink>

                  {item.subMenus && (
                    <ul className={`sub-menu ${index} ${expand === index ? 'activeside' : ''}`}>
                      {item.subMenus.map(ele =>
                        ele.link ? (
                          <NavLink key={ele.id} to={ele.link} style={{textDecoration: 'none'}}>
                            <li className={`sideitem row ${ele.className}`} onClick={() => sidebarHandleClick(ele.text)}>
                              <div className='col-2 px-0 mx-0'>{ele.icon}</div>
                              <span className={sideactive ? 'linkText col-6' : 'linkTextclosed col-6'}>
                                <NavLink className='nav-link' to={ele.link} style={{textDecoration: 'none'}}>
                                  {ele.text}
                                </NavLink>
                              </span>
                            </li>
                          </NavLink>
                        ) : null
                      )}
                    </ul>
                  )}
                </div>
              ) : null
            )}
          </ul>
        </div>
      </div>
    </div>
  );
}

export default SideBar;
